





import Vue, { PropType } from 'vue'
import type { Element } from '../UiForm.types'
import UiFieldset from '../../UiFieldset'

export default Vue.extend({
  name: 'UiFormFieldset',
  components: {
    UiFieldset
  },
  inheritAttrs: false,
  props: {
    field: {
      type: Object as PropType<Element>,
      required: true
    }
  }
})
